import script from "./RatingScale.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingScale.vue?vue&type=script&setup=true&lang=js"

import "./RatingScale.vue?vue&type=style&index=0&id=63a9662a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a9662a"]])

export default __exports__